<template>
  <v-dialog
    v-model="showModal"
    persistent
    max-width="700px"
    @keydown.enter.prevent="submit()"
    @keydown.esc.prevent="cancel()"
  >
    <v-card class="modalCard">
      <v-card-title class="modalTitle pt-2 pb-1 mb-2">
        <h2>{{ showTitle }}</h2>
      </v-card-title>
      <v-card-text class="pt-2 pb-2">
        <v-card class="mb-2 py-4">
          <v-card-text>
            <v-row no-gutters>
              <v-col cols="12" v-html="text"></v-col>
            </v-row>
            <v-row no-gutters v-if="canDokZyma">
              <v-col cols="12"
                ><el-checkbox
                  label="Dokumentų kopijas teikti su žymomis"
                  v-model="item.dokZyma"
              /></v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-card-text>
      <v-card-actions class="modalActions" elevation="5">
        <v-spacer></v-spacer>
        <el-button v-if="showCancel" @click.native="cancelData()">
          {{ cancelButton }}
        </el-button>
        <el-button v-if="showSave" primary @click.native.stop="saveData()">
          {{ saveButton }}
        </el-button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ModalConfirm',
  props: {
    title: String,
    text: String,
    action: String,
    item: Object,
    value: Boolean,
    saveBnt: String,
    showSave: { type: Boolean, default: true },
    showCancel: { type: Boolean, default: true },
  },
  data() {
    return {}
  },
  computed: {
    showTitle() {
      return this.title
    },
    showModal: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    modalAction() {
      return this.action ? this.action : 'Confirm'
    },
    canDokZyma() {
      return this.item && this.item.canDokZyma
    },
    saveButton() {
      return this.saveBnt ?? this.$t('Tęsti')
    },
    cancelButton() {
      return this.cancelBnt ?? this.$t('Atšaukti')
    },
  },
  methods: {
    saveData() {
      this.$emit('confirm' + this.modalAction, this.item)
      this.closeModal()
    },
    cancelData() {
      this.$emit('cancelConfirm', this.item)
      this.closeModal()
    },
    closeModal() {
      this.showModal = false
    },
    submit() {
      this.saveData()
    },
    cancel() {
      this.cancelData()
    },
  },
}
</script>
<style lang="scss" scoped>
.modalCard {
  background: #f5f5f5 !important;
}
.modalTitle {
  background: #f5f5f5 !important;
  position: sticky;
  top: 0;
  z-index: 2;
  background: none;
  border-bottom: thin solid rgba(0, 0, 0, 0.12);
}
.modalActions {
  position: sticky;
  bottom: 0;
  z-index: 1;
}
</style>
